import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Form,
  Col,
  Row,
  Modal,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderTitle,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import { useDispatch, useSelector } from "react-redux";
import {
  addItem,
  editItem,
  fetchId,
  fetchIdNoloading,
  resetData,
  selectId,
  selectLoading,
} from "./initialloadSlice";
import { useHistory, useParams } from "react-router";
import {
  showSuccessDialog,
  showErrorDialog,
  GOOGLE_KEY,
  allDay,
  getValueStatus,
  createChangeHandler,
  CallApi,
  paramsMasterAll,
  setOptionsMaster,
  showDialog,
  useForceUpdate,
  showDeleteDialog,
  formatQuantity,
  formatterStatus,
} from "../../utility";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import { Marker } from "../../utility/Marker";
import GoogleMapReact from "google-map-react";
import Select from "react-select";
import { selectUser } from "../../modules/Auth/_redux/authRedux";
import CurrencyInput from "react-currency-input-field";
import BootstrapTable from "react-bootstrap-table-next";
import cellEditFactory from "react-bootstrap-table2-editor";

import {
  sortCaret,
  headerSortingClasses,
  PleaseWaitMessage,
  NoRecordsFoundMessage,
  toAbsoluteUrl,
} from "../../../_metronic/_helpers";
import { fetchCustomer, selectCustomer } from "../customer/customerSlice";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import InputNumber from "../../utility/InputNumber";
import SVG from "react-inlinesvg";
import {
  fetchProduct,
  fetchTemplate,
  selectProduct,
} from "../product/productSlice";
import { uploadItem, uploadValidate } from "./initialloadSlice";

export const InitialloadCreate = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const loading = useSelector(selectLoading);
  const user = useSelector(selectUser);
  const dataId = useSelector(selectId);
  const dataCustomer = useSelector(selectCustomer);
  const dataProduct = useSelector(selectProduct);
  const { id } = useParams();
  const { SearchBar } = Search;
  const forceUpdate = useForceUpdate();
  const ref = useRef();

  const [tableData, setTableData] = useState([]);
  const [tableDataProduct, setTableDataProduct] = useState([]);
  const [show, setShow] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);

  const paramsId = {
    user_id: id,
  };

  useEffect(() => {
    async function fetchMyAPI() {
      await dispatch(resetData());
      if (id !== undefined) {
        await CallApi(paramsId, fetchId, dispatch);
      }

      await dispatch(fetchProduct({ ...paramsMasterAll, is_active: true }));
    }
    fetchMyAPI();
  }, [dispatch]);

  useEffect(() => {
    if (dataId) {
      const initData = dataId?.initial_load_settings.map((item, index) => {
        return {
          ...item,
          no: index + 1,
          initial_load_quantity: parseInt(item.initial_load_quantity),
        };
      });

      setTableData(initData);
    }
  }, [dataId]);
  useEffect(() => {
    if (dataProduct !== null) {
      const initData = dataProduct?.map((item, index) => {
        return {
          ...item,
          no: index + 1,
          initial_load_quantity: 0,
          product_code: item.product_code,
          product_name: item.product_name,
          product_id: item.product_id,
        };
      });

      setTableDataProduct(initData);
    }
  }, [dataProduct]);

  const handleSave = async () => {
    const updatedTableData = tableData.map((item) => {
      const { no, ...rest } = item;
      return {
        ...rest,
        user_id: dataId.user_id,
      };
    });

    const params = {
      user_id: dataId.user_id,
      details: updatedTableData,
    };

    try {
      const response =
        id === undefined
          ? await dispatch(addItem(params))
          : await dispatch(editItem(params));
      if (response.payload.status === 200) {
        await showSuccessDialog(response.payload.message);
        (await id) === undefined
          ? history.goBack()
          : await CallApi(paramsId, fetchIdNoloading, dispatch);
      } else {
        showErrorDialog(response.payload.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
      console.log(error.message);
    }
  };

  const handleQty = (e, row, rowIndex, formatExtraData) => {
    if (
      row.initial_load_quantity === undefined ||
      row.initial_load_quantity < 0
    ) {
      row.initial_load_quantity = 0;
      forceUpdate();
      return;
    }
  };

  const inputQtyFormmater = (e, row, rowIndex, formatExtraData) => {
    return (
      <input
        type="number"
        className="input-qty"
        step="any"
        value={parseInt(row.initial_load_quantity)}
        onBlur={handleQty(e, row, rowIndex, formatExtraData)}
      />
    );
  };

  // add product

  const actionFormatter = (e, row) => {
    return (
      <div>
        <OverlayTrigger
          overlay={<Tooltip id="products-delete-tooltip">Delete</Tooltip>}
        >
          <div
            className="btn btn-icon btn-light btn-hover-danger btn-sm"
            onClick={() => handleDelete(row)}
          >
            <span className="svg-icon svg-icon-md svg-icon-danger">
              <SVG src={toAbsoluteUrl("/media/svg/icons/General/Trash.svg")} />
            </span>
          </div>
        </OverlayTrigger>
      </div>
    );
  };

  const handleDelete = async (row) => {
    const action = await showDeleteDialog(
      `Are you sure want to delete?<br><strong>${row.product_name}</strong>`
    );
    if (action.isConfirmed) {
      setTableData((prevData) => {
        const filteredData = prevData.filter((item) => item.no !== row.no);
        return filteredData.map((item, index) => ({
          ...item,
          no: index + 1,
        }));
      });
    }
  };

  const columns = [
    {
      text: "No",
      dataField: "no",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "60px" },
      editable: false,
    },

    {
      text: "product Code",
      dataField: "product_code",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
      editable: false,
    },
    {
      text: "product name",
      dataField: "product_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
      editable: false,
    },
    {
      text: "UOM",
      dataField: "uom_description",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
      editable: false,
    },
    {
      text: "qty",
      dataField: "initial_load_quantity",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { maxWidth: "100px" },
      // editable: false,
      formatExtraData: tableData,
      formatter: inputQtyFormmater,
      editorRenderer: (editorProps, value) => {
        return <InputNumber {...editorProps} value={value} />;
      },
    },
    {
      text: "Action",
      dataField: "action",
      align: "center",
      formatter: actionFormatter,
      editable: false,
    },
  ];
  const columnsProduct = [
    {
      text: "No",
      dataField: "no",
      style: { minWidth: "60px" },
    },

    {
      text: "code",
      dataField: "product_code",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
    },
    {
      text: "name",
      dataField: "product_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
    },
    {
      text: "Uom",
      dataField: "uom_description",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
    },
  ];

  const handleCloseProduct = () => {
    setShow(false);
  };

  const handleSubmit = () => {
    const result = selectedRows.filter(
      (elem) =>
        !tableData.find(
          ({ product_code }) => elem.product_code === product_code
        )
    );
    setTableData((data) => [
      ...data,
      ...result.map((item, index) => ({
        ...item,
        no: data.length + index + 1,
      })),
    ]);
    setSelectedRows([]);
    handleCloseProduct();
  };

  const onSelectRow = {
    mode: "checkbox",
    // clickToSelect: true,
    onSelectAll: (isSelect, rows) => {
      if (isSelect) {
        const filteredRows = rows.filter(
          (row) =>
            !tableData.some(
              (selectedRow) => selectedRow.product_code === row.product_code
            )
        );
        setSelectedRows([...selectedRows, ...filteredRows]);
      } else {
        setSelectedRows([]);
      }
    },
    onSelect: (row, isSelect) => {
      console.log(row, "row");
      if (isSelect) {
        if (
          tableData.filter((e) => e.product_code === row.product_code).length >
          0
        ) {
          showDialog("Already selected");
          return false;
        }
        setSelectedRows([...selectedRows, row]);
      } else {
        const index = selectedRows.indexOf(row);
        if (index > -1) {
          selectedRows.splice(index, 1);
        }
      }
      return true;
    },
  };

  // upload
  const [showUpload, setShowUpload] = useState(false);
  const [fileUpload, setFileUpload] = useState(null);
  const [tableUpload, setTableUpload] = useState([]);

  const handleShowUpload = (data) => {
    setShowUpload(true);
  };

  const handleCloseUpload = () => {
    setTableUpload([]);
    setShowUpload(false);
  };

  const handleUpload = async () => {
    const params = tableUpload
      .filter((entry) => entry.status_validation === "Success")
      .map((item) => {
        return {
          ...item,
          user_id: id,
        };
      });

    if (params.length === 0) {
      return showDialog("Please upload data first");
    }

    try {
      const response = await dispatch(uploadItem(params));
      console.log(response, "response");
      if (response.payload.status === 200) {
        await showSuccessDialog(response.payload.message);
        await window.location.reload();
      } else {
        showErrorDialog(response.payload.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
      console.log(error.message);
    }
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    setFileUpload(selectedFile);
    validateFile(selectedFile);
  };

  const validateFile = async (file) => {
    if (file) {
      try {
        const response = await dispatch(uploadValidate(file));
        console.log(response, "response");
        if (response.payload.status === 200) {
          const initData = response.payload.data.data.map((item, index) => {
            return {
              ...item,
              no: index + 1,
            };
          });
          setTableUpload(initData);
        } else {
          showErrorDialog(response.payload.message);
        }
      } catch (error) {
        showErrorDialog(error.message);
        console.log(error.message);
      }
    } else {
      console.log("No file uploaded");
    }
  };

  const columnsUpload = [
    {
      text: "No",
      dataField: "no",
      style: { minWidth: "60px" },
    },

    {
      text: "code",
      dataField: "product_code",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
    },
    {
      text: "name",
      dataField: "product_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
    },

    {
      text: "uom",
      dataField: "uom_code",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
    },

    {
      text: "initial_load_quantity",
      dataField: "initial_load_quantity",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
      formatter: formatQuantity,
      align: "right",
    },
    {
      text: "status",
      dataField: "status_validation",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
      formatter: formatterStatus,
    },
    {
      text: "message",
      dataField: "message_validation",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
    },
  ];

  const handleDownload = async () => {
    const params = {
      file_type: "INITIAL_LOAD",
      user_id: id,
    };
    try {
      const response = await dispatch(fetchTemplate(params));
      if (response.payload.status === 200) {
        const blob = new Blob([response.payload.data], {
          type: "application/xlsx",
        });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "INITIAL_LOAD.xlsx";
        link.click();
      } else {
        showErrorDialog(response.payload.data.message);
        console.log("else");
      }
    } catch (error) {
      console.log("catch");
      showErrorDialog(error.message);
    }
  };

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <>
      <Card>
        <CardHeader>
          <CardHeaderTitle className="card-title">
            {id === undefined
              ? "Create Initial Load Setting"
              : "Edit Initial Load Setting"}
          </CardHeaderTitle>
          <CardHeaderToolbar>
            <Button
              className="btn btn-secondary mr-3"
              onClick={() => history.goBack()}
            >
              <i className="fa fa-arrow-left"></i>Back
            </Button>
            {dataId !== undefined && (
              <Button
                className="btn btn-warning mr-3"
                onClick={handleShowUpload}
              >
                Upload
              </Button>
            )}

            <Button
              className="btn btn-danger"
              onClick={(e) => {
                handleSave();
              }}
            >
              Save
            </Button>
          </CardHeaderToolbar>
        </CardHeader>

        <CardBody>
          <Form>
            <Form.Group as={Row}>
              <Col sm={6}>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Sales Code</b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control
                      type="text"
                      disabled
                      value={dataId?.company_sales_code}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>List Product</b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control type="text" disabled />
                  </Col>
                  <Col>
                    <div
                      className="btn btn-icon btn-light btn-hover-danger btn-sm  mr-3"
                      onClick={() => setShow(true)}
                    >
                      <span className="svg-icon svg-icon-md svg-icon-secondary">
                        <SVG
                          src={toAbsoluteUrl("/media/svg/icons/Code/Plus.svg")}
                        />
                      </span>
                    </div>
                  </Col>
                </Form.Group>
              </Col>
              {/* Right Row */}

              <Col sm={6}>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Sales Name</b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control type="text" disabled value={dataId?.name} />
                  </Col>
                </Form.Group>
              </Col>
            </Form.Group>
          </Form>

          <ToolkitProvider
            keyField="no"
            data={tableData}
            columns={columns}
            search
          >
            {(props) => (
              <div>
                <Row>
                  <Col>
                    <div className="float-right">
                      <SearchBar
                        {...props.searchProps}
                        placeholder="Search .."
                      />
                    </div>
                  </Col>
                </Row>
                <div className="table-container ">
                  <BootstrapTable
                    // wrapperClasses="table-responsive"
                    classes="table table-head-custom table-vertical-center"
                    bootstrap4
                    bordered={true}
                    {...props.baseProps}
                    cellEdit={cellEditFactory({
                      mode: "click",
                      blurToSave: true,
                    })}
                  />
                </div>
              </div>
            )}
          </ToolkitProvider>
        </CardBody>
      </Card>

      <Modal
        show={show}
        onHide={handleCloseProduct}
        size="lg"
        dialogClassName="modal-70"
      >
        <Modal.Header closeButton>
          <Modal.Title>Add Product</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ToolkitProvider
            keyField="no"
            data={tableDataProduct}
            columns={columnsProduct}
            search
          >
            {(props) => (
              <div>
                <Row>
                  <Col>
                    <div className="float-right">
                      <SearchBar
                        {...props.searchProps}
                        placeholder="Search .."
                      />
                    </div>
                  </Col>
                </Row>
                <div className="table-container ">
                  <BootstrapTable
                    // wrapperClasses="table-responsive"
                    classes="table table-head-custom table-vertical-center"
                    bootstrap4
                    bordered={true}
                    {...props.baseProps}
                    selectRow={onSelectRow}
                  />
                </div>
              </div>
            )}
          </ToolkitProvider>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => handleCloseProduct()}>
            Close
          </Button>
          <Button variant="danger" onClick={handleSubmit}>
            Submit
          </Button>{" "}
        </Modal.Footer>
      </Modal>

      <Modal
        show={showUpload}
        onHide={handleCloseUpload}
        size="lg"
        dialogClassName="modal-70"
      >
        <Modal.Header closeButton>
          <Modal.Title>Upload Initial Load</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group as={Row}>
            <Col sm={6}>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>
                    File <b className="color-red">*</b>
                  </b>
                </Form.Label>
                <Col sm={6}>
                  <Form.Control
                    ref={ref}
                    type="file"
                    label="Input "
                    onChange={handleFileChange}
                    custom
                    accept=".xlsx"
                  />
                </Col>
              </Form.Group>
            </Col>
            <Col sm={6}>
              <Button variant="warning" onClick={() => handleDownload()}>
                Download Template
              </Button>
            </Col>
          </Form.Group>

          {tableUpload.length > 0 && (
            <BootstrapTable
              wrapperClasses="table-responsive"
              classes="table table-head-custom table-vertical-center overflow-hidden rounded mt-5"
              bootstrap4
              keyField="no"
              data={tableUpload}
              columns={columnsUpload}
              hover
              striped
            ></BootstrapTable>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => handleCloseUpload()}>
            Close
          </Button>
          <Button variant="danger" onClick={handleUpload}>
            Save
          </Button>{" "}
        </Modal.Footer>
      </Modal>
    </>
  );
};
